<script>

import { common } from "../../mixins/common.mixin";
import {
  IV_SUBMENU,
  IV_MENU_GROUP,
  IV_MENU_ITEM,
  findNode
} from "@/routes/";

function renderNavi(h, items){
    return (vm)=>{
        return items
          .filter(i=>(typeof i.shown == 'undefined'?true:i.shown))
          .map(node=>{
            // const element = vm.components[vm.types[node.type]]
            const element = node.type
            const $title = h('span', {
                ...(node.type!==IV_MENU_ITEM ? {slot:'title'} : {})
            }, [
                node.icon ? <iv-icon type={node.icon} /> : '',
                node.title
            ])
            return h(element, {
                props:{
                    title: node.title,
                    name: node.name,
                    id: node.name
                }
            }, [
                $title,
                node.children ? renderNavi(h, node.children)(vm) : ''
            ])
        })
    }
}

export default {
    props: {
        active: String,
        opens: Array,
        list: {
          type: Array,
          default:()=>[]
        },
        theme: {
          type: String,
          default: "light"
        },
        mode: {
          type: String,
          default: "horizontal"
        }
    },
    mixins: [common],
    render(h){
        return h('iv-menu', {
            ref: 'menu',
            props: {
                "theme":this.theme,
                "mode":this.mode,
                "width": this.mode !== 'horizontal'?"auto":undefined,
                "active-name": this.activeName,
                "open-names": this.openNames
            },
            // class: "adm-navi",
            on: {
                'on-select':(name)=>{
                    this.onSelect(name)
                }
            }
        },
        [
            h('div', this.$slots.logo),
            renderNavi(h, this.items)(this)
        ])
    },
    data(){
        return {
            activeName: this.active,
            openNames: [],
            types: ['sub','group','item'],
            components: ['iv-submenu','iv-menu-group','iv-menu-item'],
            items: this.list
        }
    },
    watch: {
        active(val){
            this.activeName = val;
        },
        opens(val){
            this.openNames = val || [];
            this.$nextTick(()=>{
                this.$refs.menu.updateOpened();
            });
        },
        list(val){
          this.items = val
        }
    },
    methods: {
        onSelect(name){
            const activeNode = findNode(name, this.items)
            this.jump(activeNode);
        },
        jump(node){
            if(node.type !== IV_MENU_ITEM) return;
            // const path = node.path || `/${node.id}`;
            this.$router.push({ path:node.path });
        },
    }
}
</script>
<style lang="scss">
.ivu-menu-horizontal.ivu-menu-light:after{
    background: none;
}
.adm-navi{
    flex-grow: 1;
    // overflow-y: auto;
    &::-webkit-scrollbar{
        width: 3px;
    }
    &::-webkit-scrollbar-track{
        background-color: rgba(0,0,0, .5);
    }
    &::-webkit-scrollbar-thumb{
        background-color: #495060;
        border-radius: 10px;
    }
}
</style>
